import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './reducer/store';
//import { PersistGate } from 'redux-persist/integration/react';
import "./js/api/axiosInterceptor";
import { msalInstance } from './auth-config';
import { MsalProvider } from "@azure/msal-react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MsalProvider instance={msalInstance}>
        <Provider store={store}>
            <App />
        </Provider>
    </MsalProvider>
);
